// extracted by mini-css-extract-plugin
module.exports = {"h4":"PaymentFailedPage_h4__B7ptB","imageWrapper":"PaymentFailedPage_imageWrapper__pXO3J","buttonWrapper":"PaymentFailedPage_buttonWrapper__tO2_X"};